import { transactionApi } from "../../config/axiosConfig";
import {
  QR_INIT_MANUAL,
  QR_MANUAL_CHECK,
  VERIFY_MANUAL_TRANSACTION,
} from "../constants/transaction";
import { message } from "antd";

const postQrInitManualTransaction =
  (data, navigation, id, endpoint) => async (dispatch) => {
    dispatch({
      type: QR_INIT_MANUAL.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.post(
        `transaction/${endpoint === 'thb' ? 'thb' : 'qr'}-create-payment`,
        data
      );
      if (apiCall.status == 200) {
        dispatch({
          type: QR_INIT_MANUAL.SUCCESS,
          payLoad: apiCall.data.data,
        });
        if (apiCall.data.data.message) {
          message.success(apiCall.data.data.message, 3);
        }
        if (endpoint === 'thb') {
          window.open(apiCall.data.data.qrUrl, "_self");
        } else {
          dispatch({
            type: "WARNING_MODAL_CLOSE",
            payLoad: false,
            data: data,
          });
          navigation(`/${id}/${data.type}-payment-method/qr-code-info`);
        }
      }
    } catch (error) {
      dispatch({
        type: "WARNING_MODAL_CLOSE",
        payLoad: false,
        data: data,
      });
      dispatch({
        type: QR_INIT_MANUAL.ERROR,
        payLoad: error.response
          ? error.response.data.error.split(":")[1]
          : "some thing went wrong",
      });
      navigation(`/${id}`);
    }
  };

export default postQrInitManualTransaction;

// ----------FOR MYR CURRENCY--------------
export const postMyrCreateTransaction =
  (data, navigation, id, endpoint, trafficShift) => async (dispatch) => {
    dispatch({
      type: QR_INIT_MANUAL.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.post(
        `${endpoint == "myrfpx" ? "myrsc" : endpoint}/transaction${endpoint == "myrfpx" ? "myr" : endpoint
        }/${endpoint == "myrfpx" ? "myr" : endpoint}-create-payment`,
        data
      );
      
      if (apiCall.data.statusCode == 200) {
        if(trafficShift){
          if(apiCall.data.data.qrUrl){
            window.open(apiCall.data.data.qrUrl, "_self");
          }else{
            navigation(`/vnd/${id}/qr-code-info`)
          }
        }else if (data.type == "ob-script") {
          window.open(apiCall.data.data.payUrl, "_self");
        } else if (data.type == "fpx") {
          window.open(
            apiCall.data.data.p_url || apiCall.data.data.payUrl,
            "_self"
          );
        } else if (data.type == "vietqr") {
          // REDIRECTION FOR VND
          navigation(`/vnd/${id}/vndefg-qr-code-info`);
        } else if (data.type == "duitnowqr") {
          navigation(`/${endpoint}/${id}/duitnowqr-payment-method/qr-code-info`);
        }
        dispatch({
          type: QR_INIT_MANUAL.SUCCESS,
          payLoad: apiCall.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: QR_INIT_MANUAL.ERROR,
        payLoad: error.response
          ? error.response.data.message || error.response.data.error.split(":")[1]
          : "some thing went wrong",
      });
    }
  };

// ----------FOR IDR CURRENCY--------------
export const postIdrCreateTransaction =
  (data, navigation, id) => async (dispatch) => {
    dispatch({
      type: QR_INIT_MANUAL.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.post(
        `idr/transactionidr/idr-create-payment`,
        data
      );
      if (apiCall.status == 200) {
        dispatch({
          type: QR_INIT_MANUAL.SUCCESS,
          payLoad: apiCall.data.data,
        });
        if (apiCall.data.data.message) {
          message.success(apiCall.data.data.message, 3);
        }
        dispatch({
          type: "WARNING_MODAL_CLOSE",
          payLoad: false,
          data: data,
        });
        setTimeout(() => {
          window.open(`${apiCall.data.data?.qrUrl}`, "_self");
        }, 1000);
        // navigation(`/idromp/${data.type}/${id}/qr-code-info`);
      }
    } catch (error) {
      dispatch({
        type: "WARNING_MODAL_CLOSE",
        payLoad: false,
        data: data,
      });
      dispatch({
        type: QR_INIT_MANUAL.ERROR,
        payLoad: error.response
          ? error.response.data.error.split(":")[1]
          : "some thing went wrong",
      });
      navigation(`/idromp/${id}`);
    }
  };
// ----------FOR MYR CURRENCY Request to check transaction status--------------
export const checkMyrCreatedTransaction =
  (transactionId, navigation, userId, endpoint) => async (dispatch) => {
    dispatch({
      type: QR_MANUAL_CHECK.LOADING,
      payLoad: true,
    });

    try {
      let url = "";
      if (endpoint === "myrfpx") {
        url = `myrsc/transactionmyr/myr-payment-check/${transactionId}`;
      } else if (endpoint === "opthb") {
        url = `transaction/qr-payment-check/${transactionId}/${userId}`;
      } else {
        url = `${endpoint}/transaction${endpoint}/${endpoint}-payment-check/${transactionId}`;
      }
      const apiCall = await transactionApi.get(url);
      if (apiCall.data.statusCode == 200) {
        dispatch({
          type: QR_MANUAL_CHECK.SUCCESS,
          payLoad: apiCall.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: QR_MANUAL_CHECK.ERROR,
        payLoad: error.response
          ? error.response.data.error.split(":")[1]
          : "some thing went wrong",
      });
    }
  };

// ----------FOR IDR CURRENCY Request to check transaction status--------------
export const checkIdrCreatedTransaction =
  (transactionId, navigation, id) => async (dispatch) => {
    dispatch({
      type: QR_MANUAL_CHECK.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.get(
        // `myr/transactionmyr/myr-payment-check/${data.transactionId}/${data.userId}`
        `idr/transactionidr/idr-payment-check/${transactionId}`
      );
      if (apiCall.data.statusCode == 200) {
        dispatch({
          type: QR_MANUAL_CHECK.SUCCESS,
          payLoad: apiCall.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: QR_MANUAL_CHECK.ERROR,
        payLoad: error.response
          ? error.response.data.error.split(":")[1]
          : "some thing went wrong",
      });
    }
  };

// ----------FOR MYR CURRENCY Request to check DuitNow QR transaction status--------------
export const checkDuitNowQrTransaction =
  (transactionId) => async (dispatch) => {
    dispatch({
      type: QR_MANUAL_CHECK.LOADING,
      payLoad: true,
    });

    try {
      let url = `myr/transactionmyr/inquire-duitnowqr-tranx/${transactionId}`;
      const apiCall = await transactionApi.get(url);
      if (apiCall.data.statusCode == 200) {
        dispatch({
          type: QR_MANUAL_CHECK.SUCCESS,
          payLoad: apiCall.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: QR_MANUAL_CHECK.ERROR,
        payLoad: error.response
          ? error.response.data.message || error.response.data.error
          : "some thing went wrong",
      });
    }
  };

// ----------FOR CNY CURRENCY--------------
export const postCnyCreateTransaction =
  (data, navigation, id) => async (dispatch) => {
    dispatch({
      type: QR_INIT_MANUAL.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.post(
        `cny/transactioncny/cny-create-payment`,
        data
      );
      if (apiCall.status == 200) {
        dispatch({
          type: QR_INIT_MANUAL.SUCCESS,
          payLoad: apiCall.data.data,
        });
        dispatch({
          type: "WARNING_MODAL_CLOSE",
          payLoad: false,
          data: data,
        });
        window.open(apiCall.data.data.payUrl, "_self");
        if (apiCall.data.data.Message) {
          message.success(apiCall.data.data.Message, 3);
        }
        // navigation(`/cny/${id}/qr-code-info`);
      }
    } catch (error) {
      dispatch({
        type: "WARNING_MODAL_CLOSE",
        payLoad: false,
        data: data,
      });
      dispatch({
        type: QR_INIT_MANUAL.ERROR,
        payLoad: error.response
          ? error.response.data.error.split(":")[1]
          : "some thing went wrong",
      });
      navigation(`/cny/${id}`);
    }
  };


  // ----------FOR FPX CURRENCY--------------
export const postMyrFPXCreateTransaction =
(data, navigation, id, endpoint, noRedirect) => async (dispatch) => {
  dispatch({
    type: QR_INIT_MANUAL.LOADING,
    payLoad: true,
  });

  try {
    let apiCall = await transactionApi.post(
      `myr/transactionmyr/create-fpx-payment`,
      data
    );
    if (apiCall.data.statusCode == 200) {
      dispatch({
        type: QR_INIT_MANUAL.SUCCESS,
        payLoad: apiCall.data.data,
      });
      if(!noRedirect){
        navigation(`/myr/fpx-redirecting/${id}`)
      }
    }
  } catch (error) {    
    message.error(
      Array.isArray(error.response?.data?.message) 
          ? error.response.data.message[0] 
          : error.response?.data?.message || "Something went wrong"
      );
      dispatch({
      type: QR_INIT_MANUAL.ERROR,
      payLoad: error.response
        ? error.response.data.message
        : "some thing went wrong",
    });
  }
};

// ----------FOR SGD CURRENCY--------------
export const postSgdCreateTransaction =
  (data, navigation, id) => async (dispatch) => {
    dispatch({
      type: QR_INIT_MANUAL.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.post(
        `sgd/transactionsgd/sgd-create-payment`,
        data
      );
      if (apiCall.data.statusCode == 200) {
        dispatch({
          type: QR_INIT_MANUAL.SUCCESS,
          payLoad: apiCall.data.data,
        });
        if (apiCall.data.data.payUrl) {
          window.open(apiCall.data.data.payUrl, "_self");
        } 
        // else {
        //   navigation(`/sgd/${id}/qr-code-info`);
        // }
      }
    } catch (error) {
      dispatch({
        type: QR_INIT_MANUAL.ERROR,
        payLoad: error.response
          ? error.response.data.message || error.response.data.error.split(":")[1]
          : "some thing went wrong",
      });
    }
  };

// ----------FOR SGD CURRENCY status check--------------
export const checkSgdTransaction = (transactionId) => async (dispatch) => {
  dispatch({
    type: QR_MANUAL_CHECK.LOADING,
    payLoad: true,
  });

  try {
    let url = `sgd/transactionsgd/sgd-payment-check/${transactionId}`;
    const apiCall = await transactionApi.get(url);
    if (apiCall.data.statusCode == 200) {
      dispatch({
        type: QR_MANUAL_CHECK.SUCCESS,
        payLoad: apiCall.data.data,
      });
    }
  } catch (error) {
    dispatch({
      type: QR_MANUAL_CHECK.ERROR,
      payLoad: error.response
        ? error.response.data.message || error.response.data.error
        : "some thing went wrong",
    });
  }
};
